import { makeStyles } from "@mui/styles";

const rolesStyles = makeStyles({
    container: {
        minHeight: window.innerHeight -135
    }
})

export default rolesStyles
